// ════════════════════════════════════════
// app/courses/web-dev.tsx
// ════════════════════════════════════════
import { CourseCategoryPage } from '@/components/seo/CourseCategoryPage';
export default function WebDevPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'קורס בניית אתרים ואפליקציות',
        metaTitle: 'קורס בניית אתרים 2025 – WordPress, React, Full Stack | Kursi',
        slug: 'web-dev',
        metaDescription: 'קורסי בניית אתרים 2025 – WordPress, Wix, React, Full Stack, Node.js. מדריך לבחירת קורס פיתוח web עם תיק עבודות. קבלו 3 המלצות קורסים אישיות.',
        subtitle: 'מ-WordPress ו-Wix ועד React ו-Full Stack — קורסי בניית אתרים לכל רמה ומטרה.',
        chips: ['WordPress', 'React', 'Full Stack', 'Wix', 'Shopify', 'No-Code'],
        chatSeed: 'קורס בניית אתרים',
        sections: [
          {
            id: 'goal',
            title: 'מה המטרה שלכם?',
            body: 'הטעות הכי נפוצה: ללמוד Full Stack כשכל מה שצריך זה WordPress לעסק. קורס טוב ישאל אתכם מה המטרה לפני שמתחילים.',
            bullets: [
              'אתר לעסק שלי — WordPress / Wix מספיקים',
              'פרילנס בבניית אתרים — WordPress + עיצוב',
              'קריירה בהייטק — React, Full Stack, Next.js',
              'חנות אונליין — Shopify, WooCommerce',
              'אפליקציה מובייל — React Native, Flutter',
            ],
          },
          {
            id: 'code',
            title: 'עם קוד או בלי קוד?',
            body: 'No-Code (Wix, Webflow) מאפשרים לבנות אתרים יפים בלי לכתוב שורת קוד. קוד (React, Next.js) נותן גמישות מלאה. בחרו לפי המטרה.',
            bullets: [
              'ללא קוד: Wix, Webflow, Framer — מהיר ונגיש',
              'WordPress: שילוב — קצת קוד, הרבה גמישות',
              'קוד מלא: HTML, CSS, JavaScript, React',
              'Full Stack: גם צד שרת (Node.js, Python)',
            ],
          },
          {
            id: 'portfolio',
            title: 'פורטפוליו — המפתח לעבודה',
            body: 'בבניית אתרים אין מה להציג בלי פורטפוליו. קורס טוב מסיים עם לפחות 3 פרויקטים שאפשר להציג ללקוחות ולמעסיקים.',
            bullets: [
              'לפחות 3 פרויקטים שונים',
              'אתר אישי / פורטפוליו',
              'פרויקט עם לקוח אמיתי (גם ללא תשלום)',
              'GitHub עם קוד מסודר (לקורסי קוד)',
            ],
          },
        ],
        checklist: [
          'הקורס מתאים למטרה שלי (עסק / פרילנס / הייטק)',
          'יש פרויקטים אמיתיים לפורטפוליו',
          'החומרים מעודכנים (לא WordPress 2019)',
          'יש תמיכה ומענה לשאלות',
          'מכסה SEO בסיסי ואבטחה',
        ],
        redFlags: [
          'קורס שמלמד רק תיאוריה ללא פרויקטים',
          'חומר על jQuery ו-Bootstrap ישן',
          'הבטחות "תבנה אתרים ב-3 ימים"',
          'אין מנחה / מנטור זמין',
        ],
        faq: [
          { q: 'האם צריך לדעת לתכנת לבנות אתר?', a: 'לא. WordPress ו-Wix לא דורשים קוד. לקריירה בהייטק — כן, צריך ללמוד JavaScript ו-React.' },
          { q: 'כמה מרוויח מפתח אתרים פרילנסר?', a: 'אתר WordPress בסיסי: 3,000–8,000₪. אתר מורכב: 10,000–30,000₪. מפתח React מנוסה: 200–400₪ לשעה.' },
          { q: 'כמה זמן לוקח ללמוד בניית אתרים?', a: 'WordPress בסיסי: 4–8 שבועות. Full Stack לרמת עבודה: 6–12 חודשים של לימוד מרוכז.' },
        ],
      }}
    />
  );
}

// ════════════════════════════════════════
// app/courses/graphic-design.tsx
// ════════════════════════════════════════
export function GraphicDesignPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'קורס עיצוב גרפי ו-UX/UI',
        metaTitle: 'קורס עיצוב גרפי ו-UX/UI 2025 – Figma, Photoshop | Kursi',
        subtitle: 'Photoshop, Illustrator, Figma ו-UX/UI — מצאו את קורס העיצוב שיוביל אתכם לקריירה או לפרילנס.',
        chips: ['Figma', 'Photoshop', 'Illustrator', 'UX/UI', 'ברנדינג', 'Motion'],
        chatSeed: 'קורס עיצוב גרפי',
        sections: [
          {
            id: 'goal',
            title: 'עיצוב גרפי או UX/UI — מה ההבדל?',
            body: 'עיצוב גרפי: לוגואים, פרסום, דפוס, ברנדינג. UX/UI: ממשקים דיגיטליים, אפליקציות, אתרים — יותר מבוקש בהייטק.',
            bullets: [
              'עיצוב גרפי: לוגו, פרסום, מיתוג, דפוס',
              'UX: מחקר משתמשים, אפיון, חווית שימוש',
              'UI: עיצוב ממשקים דיגיטליים ב-Figma',
              'Motion Design: אנימציה, After Effects',
              'Social Media Design: קריאייטיב לרשתות',
            ],
          },
          {
            id: 'tools',
            title: 'אילו כלים ללמוד?',
            body: 'Figma היא הכלי המוביל ל-UX/UI. Photoshop ו-Illustrator עדיין רלוונטיים לעיצוב גרפי. קורס טוב מלמד כלים עדכניים ולא רק ישנים.',
            bullets: [
              'Figma: חובה ל-UX/UI',
              'Photoshop: עריכת תמונות, קריאייטיב',
              'Illustrator: גרפיקה וקטורית, לוגואים',
              'After Effects: אנימציה ו-Motion',
              'Canva: קל ונגיש למתחילים',
            ],
          },
          {
            id: 'portfolio',
            title: 'פורטפוליו הוא הכול',
            body: 'בעיצוב אין קורות חיים — יש פורטפוליו. קורס טוב מסיים עם לפחות 4–6 פרויקטים מגוונים שמראים יכולת אמיתית.',
            bullets: [
              'מינימום 4–6 פרויקטים שונים',
              'כולל פרויקט לוגו + מיתוג',
              'כולל פרויקט UX/UI עם Wireframes',
              'Behance / Dribbble — פרסמו את העבודות',
            ],
          },
        ],
        checklist: [
          'הקורס מלמד כלים עדכניים (Figma, לא InDesign ישן)',
          'יש פרויקטים לפורטפוליו',
          'יש ביקורת עבודות (critique) מהמרצה',
          'מכסה גם יסודות עיצוב לא רק תוכנה',
          'המרצה עם פורטפוליו עדכני',
        ],
        redFlags: [
          'קורס שמתמקד רק בתוכנה ולא ביסודות עיצוב',
          'אין פרויקטים לפורטפוליו',
          'מרצה עם עיצובים ישנים',
          'ללא ביקורת עבודות אישית',
        ],
        faq: [
          { q: 'האם צריך כישרון טבעי לעיצוב?', a: 'לא. עיצוב הוא מיומנות שנלמדת. רוב המעצבים הטובים פיתחו את הכישורים שלהם בלמידה ותרגול.' },
          { q: 'מה עדיף — עיצוב גרפי או UX/UI?', a: 'UX/UI מבוקש יותר בהייטק ושכר גבוה יותר. עיצוב גרפי מתאים יותר לפרילנס ולעבודה עם עסקים קטנים.' },
          { q: 'כמה מרוויח מעצב גרפי פרילנסר?', a: 'לוגו: 1,500–6,000₪. UX/UI Designer בחברה: 15,000–30,000₪ בחודש עם ניסיון.' },
        ],
      }}
    />
  );
}

// ════════════════════════════════════════
// app/courses/dropshipping.tsx
// ════════════════════════════════════════
export function DropshippingPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'קורס דרופשיפינג ואיקומרס',
        metaTitle: 'קורס דרופשיפינג ואיקומרס 2025 – Shopify, אמזון | Kursi',
        subtitle: 'Shopify, אמזון FBA, דרופשיפינג — מצאו קורס שיעזור לכם לבנות עסק אונליין רווחי.',
        chips: ['Shopify', 'Amazon FBA', 'דרופשיפינג', 'TikTok Shop', 'Etsy', 'איקומרס'],
        chatSeed: 'קורס דרופשיפינג ואיקומרס',
        sections: [
          {
            id: 'model',
            title: 'איזה מודל מתאים לכם?',
            body: 'יש הבדל גדול בין דרופשיפינג, אמזון FBA ו-Print on Demand. כל מודל דורש הון, זמן ומיומנויות שונים.',
            bullets: [
              'דרופשיפינג: מכירה ללא מלאי, ספק שולח ישירות',
              'Amazon FBA: מלאי במחסני אמזון, Prime',
              'Print on Demand: הדפסה לפי הזמנה',
              'חנות Shopify עם מלאי עצמי',
              'Etsy: מוצרים ייחודיים / עבודות יד',
            ],
          },
          {
            id: 'realistic',
            title: 'מה ציפיות ריאליות?',
            body: 'רוב מתחילי הדרופשיפינג מפסידים כסף בחצי שנה הראשונה. זה לא אומר שלא שווה — אבל צריך להיכנס עם עיניים פקוחות.',
            bullets: [
              'נדרש תקציב פרסום: 3,000–8,000₪ לתחילה',
              'ממוצע: 6–12 חודשים עד רווחיות',
              'תחרות גבוהה — חשוב למצוא נישה',
              'FBA יציב יותר, דורש הון גבוה יותר',
            ],
          },
          {
            id: 'ads',
            title: 'פרסום ממומן — הלב של הדרופשיפינג',
            body: 'בלי פרסום ממומן אין מכירות. קורס דרופשיפינג טוב חייב לכסות Facebook Ads, TikTok Ads ו-Google Shopping.',
            bullets: [
              'Facebook / Meta Ads: פרסום לפי קהלים',
              'TikTok Ads: פופולרי לדרופשיפינג ב-2024–2025',
              'Google Shopping: כוונת רכישה גבוהה',
              'ניתוח נתונים ואופטימיזציה של קמפיינים',
            ],
          },
        ],
        checklist: [
          'המרצה מציג תוצאות אמיתיות (לא רק screenshots)',
          'הקורס כולל ניהול פרסום ממומן',
          'מדבר על כישלונות ולא רק הצלחות',
          'יש קהילה פעילה אחרי הקורס',
          'החומרים מעודכנים לפלטפורמות 2024–2025',
        ],
        redFlags: [
          'הבטחות "10,000$ בחודש הראשון"',
          'קורס שלא מדבר על הפסדים והוצאות',
          'מרצה שכל ההכנסה שלו מקורסים',
          'אין תמיכה אחרי הקורס',
        ],
        faq: [
          { q: 'כמה הון צריך להתחיל?', a: 'מינימום 5,000–10,000₪: תקציב פרסום + עלות קורס + כלים. עם פחות מזה, קשה להגיע לתוצאות לפני שנגמר הכסף.' },
          { q: 'מה עדיף — דרופשיפינג או אמזון FBA?', a: 'דרופשיפינג: פחות הון, יותר עבודה על פרסום. FBA: יותר הון, יציבות גבוהה יותר, אמון לקוחות של אמזון.' },
          { q: 'האם דרופשיפינג עדיין רלוונטי?', a: 'כן, אבל השוק בשל יותר. צריך נישה ממוקדת, מוצר טוב ופרסום איכותי — לא מספיק להעתיק מה שעבד ב-2020.' },
        ],
      }}
    />
  );
}

// ════════════════════════════════════════
// app/courses/accounting.tsx
// ════════════════════════════════════════
export function AccountingPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'קורס הנהלת חשבונות וחשבות שכר',
        metaTitle: 'קורס הנהלת חשבונות 2025 – חשבות שכר, ERP | Kursi',
        subtitle: 'הנהלת חשבונות, חשבות שכר, Priority ERP ומיסוי — קורסים להכשרה מקצועית ולרישיון.',
        chips: ['הנח"ש סוג 2', 'חשבות שכר', 'Priority', 'מע"מ', 'מיסוי', 'ERP'],
        chatSeed: 'קורס הנהלת חשבונות',
        sections: [
          {
            id: 'types',
            title: 'איזה קורס מתאים לכם?',
            body: 'יש הבדל בין הנהלת חשבונות לרישיון, חשבות שכר, ולימוד תוכנות ERP. הגדירו מטרה לפני שבוחרים.',
            bullets: [
              'הנח"ש סוג 1: פנקסנות בסיסית',
              'הנח"ש סוג 2: עצמאי עם לקוחות — דורש רישיון',
              'חשבות שכר: תלוש, ביטוח לאומי, מס הכנסה',
              'Priority ERP: ניהול עסקי מקיף',
              'ניתוח דוחות כספיים: לכלכלנים ומנהלים',
            ],
          },
          {
            id: 'license',
            title: 'רישיון הנהלת חשבונות — מה חובה?',
            body: 'לעבודה עצמאית עם לקוחות נדרש רישיון מהמועצה לרישוי. קורס מוכר מכין לבחינות הרישוי. בדקו שהקורס אכן מוכר.',
            bullets: [
              'רישיון מהמועצה לרישוי הנהלת חשבונות',
              'בחינות: חשבונאות, מיסים, חוק',
              'קורס מוכר = מכין לבחינות הרישוי',
              'ללא רישיון אי אפשר לעבוד עצמאית',
            ],
          },
          {
            id: 'software',
            title: 'תוכנות שחייבים לדעת',
            body: 'שוק העבודה דורש ידע בתוכנות. Priority ו-SAP הכי נפוצים. אקסל מתקדם הוא חובה לכל מנהל חשבונות.',
            bullets: [
              'Priority ERP: הכי נפוץ בישראל',
              'SAP: נפוץ בחברות גדולות',
              'חשבשבת / הנהלת חשבונות ממוחשבת',
              'אקסל מתקדם: פיבוט, נוסחאות, דוחות',
            ],
          },
        ],
        checklist: [
          'הקורס מוביל לרישיון מוכר (אם רלוונטי)',
          'יש עבודה עם תוכנות אמיתיות',
          'חומר מיסוי מעודכן לשנת המס הנוכחית',
          'יש תרגול עם תיקי לקוחות',
          'המרצה עם ניסיון מעשי בשוק',
        ],
        redFlags: [
          'קורס ללא עבודה עם תוכנות',
          'חומר מיסוי ישן (לפני עדכוני מס אחרונים)',
          'לא מכין לרישיון מוכר',
          'אין תרגול עם מקרים אמיתיים',
        ],
        faq: [
          { q: 'מה ההבדל בין הנח"ש סוג 1 לסוג 2?', a: 'סוג 1: פנקסנות בסיסית, עובד שכיר. סוג 2: מאפשר עבודה עצמאית עם לקוחות וסגירת ספרים.' },
          { q: 'כמה מרוויח מנהל חשבונות?', a: 'שכיר מתחיל: 8,000–12,000₪. עצמאי עם 10–15 לקוחות: 15,000–25,000₪ בחודש.' },
          { q: 'כמה זמן לוקח הקורס?', a: 'הנח"ש סוג 2: 6–12 חודשים. חשבות שכר: 3–4 חודשים. Priority: 2–3 חודשים.' },
        ],
      }}
    />
  );
}